import React, { useEffect, useRef, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import {
  LANDING_PAGE_PATH,
  LOGIN_PATH,
  REGISTRATION_PATH,
} from "../../utils/Constants/Paths";
import { closeModal, openModal } from "../../redux/Modals/ModalActions";
import {
  AUTH_LOGIN_TAB,
  AUTH_MODAL_OVERLAY,
  AUTH_REGISTER_TAB,
} from "../Authentication/authOverlay";
import { bankIdRelayTargetFromState } from "../../utils/criiptoFunctions";
import {
  normalizePrefillEmail,
  sanitizeAuthTarget,
} from "../../utils/authRedirect";
import RouteLoadingScreen from "./RouteLoadingScreen";
import { t } from "i18next";

function queryParamsFromLocation(location) {
  const searchParams = new URLSearchParams(location.search);
  const hashParams = new URLSearchParams(location.hash.replace(/^#/, ""));

  return {
    idToken: searchParams.get("id_token") || hashParams.get("id_token"),
    state: searchParams.get("state") || hashParams.get("state"),
    targetPath: searchParams.get("target_path") ||
      hashParams.get("target_path"),
    email: searchParams.get("email") || hashParams.get("email"),
  };
}

function appendQueryParam(url, key, value) {
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}${key}=${encodeURIComponent(value)}`;
}

export const AuthRedirect = ({ openModal }) => {
  const location = useLocation();
  const {
    idToken,
    state,
    targetPath,
    email,
  } = queryParamsFromLocation(location);
  const safeTargetPath = sanitizeAuthTarget(targetPath);
  const initialEmail = normalizePrefillEmail(email);

  const pathname = location.pathname;

  const relayTargetPath = bankIdRelayTargetFromState(state);

  const openAuthModalRef = useRef(null);
  const [authModalOpened, setAuthModalOpened] = useState(false);

  useEffect(() => {
    if (idToken && relayTargetPath) {
      window.location.replace(
        appendQueryParam(relayTargetPath, "id_token", idToken),
      );
      return;
    }

    const tabPath =
      pathname.includes("login") || pathname === "/login"
        ? AUTH_LOGIN_TAB
        : AUTH_REGISTER_TAB;

    if (!openAuthModalRef.current) {
      openModal(AUTH_MODAL_OVERLAY, {
        idToken: idToken,
        targetPath: safeTargetPath,
        formData: initialEmail ? { email: initialEmail } : undefined,
        initialTab: tabPath,
      });

      openAuthModalRef.current = true;
      setAuthModalOpened(true);

      if ([REGISTRATION_PATH, LOGIN_PATH].includes(pathname)) {
        window.history.replaceState(
          window.history.state,
          "",
          LANDING_PAGE_PATH,
        );
      }
    }
  }, [
    idToken,
    initialEmail,
    openModal,
    pathname,
    relayTargetPath,
    safeTargetPath,
  ]);

  if ((idToken && relayTargetPath) || !authModalOpened) {
    return <RouteLoadingScreen message={t("auth.entry.loading")} />;
  }

  return (
    <Navigate
      to={(() => {
        if (![REGISTRATION_PATH, LOGIN_PATH].includes(pathname)) {
          return safeTargetPath;
        }

        return LANDING_PAGE_PATH;
      })()}
    />
  );
};

export default connect(null, {
  openModal,
  closeModal,
})(AuthRedirect);
